<section id="main_pricing_container"
  class="h-screen slide px-4 md:px-14 lg:px-[108px] flex items-center relative bg-blue_100">
  <div class="flex flex-col gap-6" [@fadeInLeftOnEnter]>
    <div class="flex flex-col gap-4 text-white">
      <h1 class="text-hurrey-28 lg:text-hurrey-48" id="pricing_page_main_head">Get In Touch with Us</h1>
    </div>
    <p class="text-hurrey-16 text-white" id="pricing_page_main_description"> We're Here to Help. We value your feedback
      and inquiries. <br class="hidden md:block lg:hidden"> Please fill out the form below <br class="hidden lg:block">
      to reach us. We will respond promptly.</p>
  </div>
</section>

<div class="contact-content">
  <div class="contact-form-section">
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" *ngIf="!isLoading">
      <div class="form-group">
        <label for="name">Full Name</label>
        <input type="text" id="name" formControlName="name" [class.error]="(name.touched || name.dirty) && name.invalid">
        <div class="error-message" *ngIf="(name.touched || name.dirty) && name.invalid">
          <span *ngIf="name.hasError('required')">Full Name is required</span>
          <span *ngIf="name.hasError('minlength')">Full Name must be at least 2 characters</span>
        </div>
      </div>

      <div class="form-group">
        <label for="email">Email Address</label>
        <input type="email" id="email" formControlName="email" [class.error]="(email.touched || email.dirty) && email.invalid">
        <div class="error-message" *ngIf="(email.touched || email.dirty) && email.invalid">
          <span *ngIf="email.hasError('required')">Email is required</span>
          <span *ngIf="email.hasError('email')">Please enter a valid email address</span>
        </div>
      </div>

      <div class="form-group">
        <label for="subject">Subject</label>
        <input type="text" id="subject" formControlName="subject" [class.error]="(subject.touched || subject.dirty) && subject.invalid">
        <div class="error-message" *ngIf="(subject.touched || subject.dirty) && subject.invalid">
          <span *ngIf="subject.hasError('required')">Subject is required</span>
          <span *ngIf="subject.hasError('minlength')">Subject must be at least 5 characters</span>
        </div>
      </div>

      <div class="form-group">
        <label for="message">Message</label>
        <textarea id="message" formControlName="message" rows="6" [class.error]="(message.touched || message.dirty) && message.invalid"></textarea>
        <div class="error-message" *ngIf="(message.touched || message.dirty) && message.invalid">
          <span *ngIf="message.hasError('required')">Message is required</span>
          <span *ngIf="message.hasError('minlength')">Message must be at least 10 characters</span>
        </div>
      </div>

      <button type="submit" class="submit-btn" [disabled]="isLoading">Send Message</button>
    </form>

    <div *ngIf="isLoading" class="loading-container">
      <span class="loader"></span>
      <p class="loading-text">Sending your message...</p>
    </div>
  </div>

  <div class="contact-info-section">
    <div class="info-item">
      <h3>Email</h3>
      <p><a href="mailto:info@theatomo.com">info&#64;theatomo.com</a></p>
    </div>

    <div class="info-item">
      <h3>Phone</h3>
      <p><a href="tel:+919019575844">+91 90195 75844</a></p>
    </div>

    <div class="info-item">
      <h3>Our Location</h3>
      <div class="locations-container">
        <div class="location-item">
          <img src="../../../../assets/icons/location_icon.webp" class="location-icon" alt="location_icon" width="16" height="16">
          <address class="location-address">71-75, Shelton Street, Covent Garden, London, WC2H 9JQ, United Kingdom</address>
        </div>

        <div class="location-item">
          <img src="../../../../assets/icons/location_icon.webp" class="location-icon" alt="location_icon" width="16" height="16">
          <address class="location-address">2nd floor, 21A Vasudev Chambers, Old Nagardas Rd, Andheri East, Mumbai, Maharashtra 400069</address>
        </div>

        <div class="location-item">
          <img src="../../../../assets/icons/location_icon.webp" class="location-icon" alt="location_icon" width="16" height="16">
          <address class="location-address">#42, 6th Avenue, Gayatri Nagar, Medavakkam, Chennai-600100</address>
        </div>
      </div>
    </div>
  </div>

  <!-- Submission messages -->
  <div *ngIf="successMessage || errorMessage" class="submission-message">
    <div class="message-box" [ngClass]="{'success': successMessage, 'error': errorMessage}">
      <p class="message-text">{{ successMessage || errorMessage }}</p>
      <button type="button" class="message-close" (click)="dismissMessages()">✕</button>
    </div>
  </div>
</div>
